import React, { useEffect, useRef, useState } from 'react';
import { func, object, string } from 'prop-types';

export default function MyCustomHeader({
   column,
   setSort,
   showColumnMenu,
   displayName,
   tooltip,
}) {
   const [hover, setHover] = useState(false);
   const [isMenuOpen, setIsMenuOpen] = useState(false);
   const [filterActive, setFilterActive] = useState(column.isFilterActive());
   const showIcons = hover || isMenuOpen || !!sortState || filterActive;
   const menuButtonRef = useRef(null);
   const sortState = column.getSort();

   const onSortRequested = (event) => {
      let order;

      if (sortState === 'asc') {
         order = 'desc';
      } else if (sortState === 'desc') {
         order = 'none';
      } else order = 'asc';

      setSort(order, event.shiftKey);
   };

   let sortIconClass = 'ag-icon-none';
   if (sortState === 'asc') {
      sortIconClass = 'ag-icon-asc';
   } else if (sortState === 'desc') {
      sortIconClass = 'ag-icon-desc';
   }

   const filterIcon = filterActive ? 'ag-icon ag-icon-filter' : '';
   const sortIcon = `ag-icon ${sortIconClass}`;

   const onClickMenu = (event) => {
      if (showColumnMenu) {
         showColumnMenu(event.currentTarget);
         setIsMenuOpen(!isMenuOpen);
      }
   };

   useEffect(() => {
      function handleDocClick(e) {
         if (!isMenuOpen) return;
         if (!menuButtonRef?.current?.contains(e.target)) {
            setIsMenuOpen(false);
         }
      }

      document.addEventListener('mousedown', handleDocClick);
      return () => {
         document.removeEventListener('mousedown', handleDocClick);
      };
   }, [isMenuOpen]);

   useEffect(() => {
      const onFilterChanged = () => {
         setFilterActive(column.isFilterActive());
      };

      column.addEventListener('filterChanged', onFilterChanged);
      return () => {
         column.removeEventListener('filterChanged', onFilterChanged);
      };
   }, [column]);

   return (
      <div
         className='my-custom-header'
         onMouseEnter={() => setHover(true)}
         onMouseLeave={() => setHover(false)}
         title={tooltip}
      >
         {showIcons ? (
            <div className='header-icons'>
               <button
                  onClick={onSortRequested}
                  className='header-icon-button'
                  aria-label='Sort column'
               >
                  <span className={sortIcon} />
               </button>

               <button
                  ref={menuButtonRef}
                  className='ag-icon ag-icon-menu header-icon-button'
                  onClick={onClickMenu}
               />

               {filterActive && <span className={filterIcon} role='img' />}
            </div>
         ) : (
            <div className='header-title'>
               <span>{displayName}</span>
            </div>
         )}
      </div>
   );
}

MyCustomHeader.propTypes = {
   column: object.isRequired,
   setSort: func.isRequired,
   showColumnMenu: func,
   displayName: string.isRequired,
   tooltip: string,
};
